"use client";

import { useLocale } from "next-intl";
import { useContext } from "react";

import { SETTLEMENT_CURRENCY } from "@trip/constants";
import { formatCurrency } from "@trip/utils";

import { CurrencyContext } from "~/components/currency-provider";

export function useCurrencyFormatter() {
  const { currency } = useContext(CurrencyContext);
  const locale = useLocale();
  return (amount: number) =>
    formatCurrency(
      typeof currency.exchangeRate === "number"
        ? amount * currency.exchangeRate
        : amount,
      locale,
      currency.code,
    );
}

export function useSettlementCurrencyFormatter() {
  const locale = useLocale();
  return (amount: number) =>
    formatCurrency(amount, locale, SETTLEMENT_CURRENCY);
}
